function addListeners(element, details) {
    var focusedAttribute = 'data-awsui-focused';
    details.focusListener = function () {
        // If the element is already focused, don't refocus it
        if (!details.focused) {
            details.focused = true;
            // Set the focused attribute if it was not triggered by mouse event
            if (!details.mouseActive) {
                details.hasFocusedAttribute = true;
                element.setAttribute(focusedAttribute, 'true');
            }
        }
    };
    details.blurListener = function (event) {
        // Remove the focus when the mouse down event happened or
        // the blur event happened from the user interaction, ignore the window blur event
        if (details.mouseActive || event.target !== document.activeElement) {
            element.removeAttribute(focusedAttribute);
            details.focused = false;
            details.hasFocusedAttribute = false;
        }
    };
    details.mouseDownListener = function (event) {
        details.mouseActive = true;
        if (details.focused) {
            element.removeAttribute(focusedAttribute);
            details.hasFocusedAttribute = false;
        }
    };
    details.mouseUpListener = function () {
        // Change the mouseActive flag to false in the next event loop.
        // The reason is that the click event is always happened after
        // the mouseup event. If we set the mouseActive to false in the current event loop
        // the data-awsui-focused will be unintentionally added to the element.
        setTimeout(function () {
            details.mouseActive = false;
        });
    };
    element.addEventListener('focus', details.focusListener);
    element.addEventListener('blur', details.blurListener);
    document.addEventListener('mousedown', details.mouseDownListener);
    document.addEventListener('mouseup', details.mouseUpListener);
}
function removeListeners(element, details) {
    element.removeEventListener('focus', details.focusListener);
    element.removeEventListener('blur', details.blurListener);
    document.removeEventListener('mousedown', details.mouseDownListener);
    document.removeEventListener('mouseup', details.mouseUpListener);
}
function updateFocus(attributes, details) {
    // Persists the attribute between renders
    if (details.hasFocusedAttribute) {
        attributes['data-awsui-focused'] = true;
    }
}
export default function addCustomFocus(attributes) {
    function proxy(originalCallback, callback) {
        return function (element, state) {
            if (originalCallback) {
                originalCallback.call(this, element, state);
            }
            var focusableContext = state;
            focusableContext.focusableContextDetails = focusableContext.focusableContextDetails || {};
            callback.call(this, element, focusableContext.focusableContextDetails);
        };
    }
    attributes.lifecycleKey = attributes.lifecycleKey ? attributes.lifecycleKey + "-custom-focus" : 'custom-focus';
    attributes.componentDidMount = proxy(attributes.componentDidMount, function (element, details) {
        addListeners(element, details);
    });
    attributes.componentDidUpdate = proxy(attributes.componentDidUpdate, function (element, details) {
        updateFocus(attributes, details);
    });
    attributes.componentWillUnmount = proxy(attributes.componentWillUnmount, function (element, details) {
        removeListeners(element, details);
    });
}
//# sourceMappingURL=FocusHandling.js.map